// mvp-returns Phase H9 — Propose Template API client
// Endpoints at /ord/propose-templates

import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface IProposeTemplate {
  id: string;
  name: string;
  description: string | null;
  refundPercent: number;
  deductionReason: string | null;
  shippingResponsibility: string;
  shippingCost: number | null;
  shippingNotes: string | null;
  resolutionType: string;
  refundMethod: string | null;
  proposalNotesTemplate: string | null;
}

export interface IProposeTemplateListResponse {
  items: IProposeTemplate[];
}

export interface IProposeTemplateWriteInput {
  name: string;
  description?: string | null;
  refundPercent: number;
  deductionReason?: string | null;
  shippingResponsibility: string;
  shippingCost?: number | null;
  shippingNotes?: string | null;
  resolutionType: string;
  refundMethod?: string | null;
  proposalNotesTemplate?: string | null;
}

export const list = (): Promise<IProposeTemplateListResponse> =>
  httpRequest.get("/ord/propose-templates") as Promise<IProposeTemplateListResponse>;

export const create = (input: IProposeTemplateWriteInput): Promise<{ id: string }> =>
  httpRequest.post("/ord/propose-templates", input as never) as Promise<{ id: string }>;

export const update = (id: string, patch: Partial<IProposeTemplateWriteInput>): Promise<{ id: string }> =>
  httpRequest.put(`/ord/propose-templates/${id}`, patch as never) as Promise<{ id: string }>;

export const remove = (id: string): Promise<{ id: string; archived: boolean }> =>
  httpRequest.del(`/ord/propose-templates/${id}`) as Promise<{ id: string; archived: boolean }>;
